import React, { Component } from 'react';
import PropTypes from 'prop-types';

const FUTURE_DAY_COLOR = '#EAEAEA';

class CalendarDay extends Component {
  _displayTooltip = e => {
    // Since container is position: relative, the tooltip needs
    // to be calculated based on the position inside the element +
    // the padding from the outside of container
    const containerWrapper = document.querySelector('.history-container');
    const containerBounds = containerWrapper.getBoundingClientRect();

    // Half width of tooltip container
    const halfContainerWidth = 162.5;

    if (e.cancelable) {
      e.preventDefault();
    }

    var target = e.target;
    var rect = e.target.getBoundingClientRect();
    // Center of the box, minus half the width of tooltip
    var left =
      rect.left - containerBounds.left + rect.width / 2.0 - halfContainerWidth;

    //Offset it slightly from the bottom of the box
    var bottom = rect.bottom - containerBounds.top + 9;
    this.props.hoverDay(left, bottom, this.props.day, target);
  };

  render() {
    const activeDayClass =
      !this.props.hidden && this.props.color !== FUTURE_DAY_COLOR
        ? ' active'
        : '';
    return (
      <svg
        className={`day${activeDayClass}`}
        width="32"
        height="32"
        xmlns="http://www.w3.org/2000/svg"
        ref={el => (this.svg = el)}
        onMouseEnter={this._displayTooltip}
        onTouchEnd={this._displayTooltip}
        onMouseLeave={this.props.leaveDay}
      >
        <rect
          className={this.props.hidden ? 'hide' : null}
          width="32"
          height="32"
          fill={this.props.color}
        />
      </svg>
    );
  }
}

CalendarDay.defaultProps = {
  color: FUTURE_DAY_COLOR,
};

CalendarDay.propTypes = {
  day: PropTypes.object,
  color: PropTypes.string,
  hidden: PropTypes.bool,
  hoverDay: PropTypes.func,
  leaveDay: PropTypes.func,
};

export default CalendarDay;
